<div class="status">
  <div class="status-value" [ngClass]="statusColor.toLowerCase()">
    @if (isStatusDescriptionKey) {
      {{ "stateDisplayer." + statusDescription | translate }}
    }
    @if (!isStatusDescriptionKey) {
      {{ "stateDisplayer." + getStatusDescriptionKey() | translate }}
    }
    @if (isDayDisplayable()) {
      {{ "stateDisplayer.statusDays" | translate: { days: statusDays } }}
    }
  </div>
</div>
